import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";
const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: "white",
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
        paddingLeft: theme.spacing(8),
        paddingRight: theme.spacing(8),
        borderRadius: theme.spacing(1),
        [theme.breakpoints.down("sm")]: {
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
        },
    },
}));
const BoxContainer = ({ className, children }) => {
    const classes = useStyles();
    return (React.createElement("section", { className: clsx(classes.root, className) }, children));
};
export default BoxContainer;
